$shm_hitalama_map_widget_float_ai_request_changes $shm_hitalama_map_widget_float_ai_request_component
	sub /
		<= Changes_label $mol_labeler
			title \Описание изменений
			content /
			Content <= Changes $mol_textarea
				value? <=> text?
	next_request_type \changes_short
